import styled from 'styled-components';

export const ToggleLabel = styled.label`
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    top: -60px;
`;

export const ToggleInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;
    position: absolute;

    &:checked + span {
        background-color: #02108f;
    }

    &:checked + span:before {
        transform: translateX(15px);
    }
`;

export const Slider = styled.span`
    position: relative;
    display: inline-block;
    width: 35px;
    height: 18px;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;

    &:before {
        position: absolute;
        content: '';
        height: 11px;
        width: 11px;
        left: 4px;
        bottom: 3px;
        background-color: #fff;
        transition: 0.4s;
        border-radius: 50%;
    }
`;

export const LabelText = styled.span`
    font-size: 15px;
    color: ${({ isActive }) => (isActive ? '#02108f' : '#243b5f')};
    font-family: 'Source Sans Pro', 'Open Sans', sans-serif;
    font-weight: 600;
`;
